import React from 'react'
import { Span } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { GridElement } from '../GridElement'
import { GridTable } from '../GridTable'

export const TargetTableHeader: React.FC = () => {
  const { t } = useTranslation(['payments'])

  return (
    <GridTable>
      <GridElement columns={2}>
        <Span bold>{t('payments:itemisation')}</Span>
      </GridElement>

      <GridElement align="right">
        <Span bold>{t('payments:dueDate')}</Span>
      </GridElement>

      <GridElement align="right">
        <Span bold>{t('payments:sum')}</Span>
      </GridElement>
    </GridTable>
  )
}
